import React, {Component} from 'react';
import Chartentry from '../Chartentry';
import styles from  './style.css';

export default class WithModal extends Component {

    constructor() {
        super();
        this.state = {
            modalIsOpen: false,

        };
        this.closeModal = ::this.closeModal;
    }

    openModal({ps, name, valuetitle}) {
        if (this.state.modalIsOpen) {
            this.setState(
                {
                    modalIsOpen: false
                },
                ()=> {
                    this.setState(
                        {
                            chartPs: ps,
                            chartName: name,
                            valuetitle: valuetitle,
                            modalIsOpen: true
                        });
                })
        }
        else {
            this.setState(
                {
                    chartPs: ps,
                    chartName: name,
                    valuetitle: valuetitle,
                    modalIsOpen: true
                });
        }
    }

    closeModal() {
        this.setState(
            {
                modalIsOpen: false
            }
        )
    }

    render() {
        if (this.state.modalIsOpen) {
            return (
                <div className={"modal fade in "+styles.modal} style={{'display':'block'}}>
                    <div className={"modal-dialog modal-lg "+styles.modalDialog} >
                        <div className={"modal-content " + styles.modalContent}>
                            <button onClick={this.closeModal}> Закрыть</button>
                            <Chartentry {...this.props} ps={this.state.chartPs} chartName={this.state.chartName} valueTitle={this.state.valuetitle}/>
                        </div>
                    </div>
                </div>
            );
        }
        else return null;
    }
}



// WEBPACK FOOTER //
// ./src/lib/core/WithModal/index.jsx